var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailOtpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    rx: 79,
    fill: "#008DFF",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7982 114C36.2901 114 34.1977 113.164 32.5208 111.492C30.8439 109.82 30.0036 107.732 30 105.227V46.7726C30 44.2718 30.8403 42.1854 32.5208 40.5134C34.2013 38.8414 36.292 38.0036 38.7928 38H119.207C121.712 38 123.802 38.8378 125.479 40.5134C127.156 42.189 127.996 44.2754 128 46.7726V105.233C128 107.73 127.16 109.816 125.479 111.492C123.799 113.168 121.708 114.004 119.207 114H38.7982ZM79 76.6297L35.4444 48.2329V105.233C35.4444 106.206 35.7584 107.006 36.3863 107.632C37.0143 108.258 37.8182 108.571 38.7982 108.571H119.207C120.184 108.571 120.986 108.258 121.614 107.632C122.242 107.006 122.556 106.205 122.556 105.227V48.2274L79 76.6297ZM79 70.5714L120.879 43.4286H37.1213L79 70.5714ZM35.4444 48.2329V43.4286V105.233C35.4444 106.206 35.7584 107.006 36.3863 107.632C37.0143 108.258 37.8182 108.571 38.7982 108.571H35.4444V48.2329Z",
    fill: "#008DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.95 76H85.9131C85.1405 76 84.3995 76.3089 83.8532 76.8587C83.3069 77.4085 83 78.1542 83 78.9317V101.471C83 102.249 83.3069 102.994 83.8532 103.544C84.3995 104.094 85.1405 104.403 85.9131 104.403H87.9099C87.9686 104.494 88.0368 104.578 88.1135 104.655L90.9404 107.5C91.093 107.658 91.2756 107.784 91.4773 107.87C91.6791 107.956 91.896 108 92.1151 108C92.3341 108 92.551 107.956 92.7528 107.87C92.9545 107.784 93.1371 107.658 93.2897 107.5L96.1166 104.655C96.191 104.576 96.2591 104.492 96.3202 104.403H141.982C142.749 104.394 143.482 104.082 144.021 103.533C144.561 102.984 144.863 102.243 144.863 101.471V78.9317C144.863 78.1542 144.556 77.4085 144.01 76.8587C143.464 76.3089 142.723 76 141.95 76Z",
    fill: "#75FB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3951 92.8029C93.6926 92.8029 94.7444 91.7443 94.7444 90.4386C94.7444 89.1329 93.6926 88.0743 92.3951 88.0743C91.0977 88.0743 90.0459 89.1329 90.0459 90.4386C90.0459 91.7443 91.0977 92.8029 92.3951 92.8029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.773 92.8029C104.07 92.8029 105.122 91.7443 105.122 90.4386C105.122 89.1329 104.07 88.0743 102.773 88.0743C101.475 88.0743 100.423 89.1329 100.423 90.4386C100.423 91.7443 101.475 92.8029 102.773 92.8029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.148 92.8029C114.446 92.8029 115.497 91.7443 115.497 90.4386C115.497 89.1329 114.446 88.0743 113.148 88.0743C111.851 88.0743 110.799 89.1329 110.799 90.4386C110.799 91.7443 111.851 92.8029 113.148 92.8029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.524 92.8029C124.821 92.8029 125.873 91.7443 125.873 90.4386C125.873 89.1329 124.821 88.0743 123.524 88.0743C122.226 88.0743 121.174 89.1329 121.174 90.4386C121.174 91.7443 122.226 92.8029 123.524 92.8029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.899 92.8029C135.196 92.8029 136.248 91.7443 136.248 90.4386C136.248 89.1329 135.196 88.0743 133.899 88.0743C132.602 88.0743 131.55 89.1329 131.55 90.4386C131.55 91.7443 132.602 92.8029 133.899 92.8029Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOtpIcon);
export default __webpack_public_path__ + "static/media/emailOtpIcon.60cde56d1a7470c9bdc761b97a171b5a.svg";
export { ForwardRef as ReactComponent };